import thunk from "redux-thunk";
import dynamicMiddlewares from "redux-dynamic-middlewares";

import { fetchMe } from "./actions/profileActions";
import { createReduxStore } from "./utils/store";
import { renderSecureNotes } from "./SecureNotes";

export const init = ({ isDevelopment, dataVersion, datadogMiddleware }) => {
  const store = createReduxStore({
    isDevelopment,
    middlewares: [datadogMiddleware, dynamicMiddlewares, thunk]
  });

  //render profile as soon as possible - show loading spinner
  renderSecureNotes({ store });

  store.dispatch(fetchMe(dataVersion));
};
